import React from "react";
import { Link } from "react-router-dom";

function DashboardHome({ items, name }) {
  return (
    <section className="home-dashboard">
      <h3>Welcome Back {name} !</h3>
      <figure className="grid-4">
        {items.map((item) => (
          <Link to={item.to} key={item.id} className="grid-card">
            <div className="top-section">
              <div className="img-container">
                <img src={item.imgLink} alt={item.title} />
              </div>
              <h3>{item.title}</h3>
            </div>
            <div className="bottom-section">
              <p>{item.description}</p>
            </div>
          </Link>
        ))}
      </figure>
    </section>
  );
}

export default DashboardHome;
